import React from 'react';
import Footer from '../../components/Footer';

function AboutPage() {
  return (
    <main className="contact-page">
      <div className="doc-container">
        <div className="contact-hero">
          <span className="contact-eyebrow">The story behind Hold On</span>
          <h1 className="contact-title">
            Built for the hour
            <br />
            <em>you didn't mean to spend.</em>
          </h1>
        </div>

        <div className="contact-body">
          <p className="contact-lead">I built Hold On for myself.</p>
          <p>
            I was already using screen time apps but after a few days, the nudges stopped working.
            Same message, every time. I'd tap through without even reading it.
          </p>
          <blockquote className="contact-pullquote">
            "That's when I realised the problem wasn't my phone. It was the intervention itself."
          </blockquote>
          <p>
            So I thought: what if the message actually changed? What if it matched the moment —
            how far over your limit you are, what time of day it is, how you've been responding?
          </p>
          <p>
            And the other thing that bothered me: other apps block you the second you open. But
            some social media is fine. Catching up with friends, staying in the loop — that's not
            the problem. The problem is the hour you didn't mean to spend.
          </p>
          <blockquote className="contact-pullquote">
            "Hold On works differently. You set a limit. We stay out of your way until you're
            close to it. Then we step in — with something you might actually read."
          </blockquote>

          <div className="contact-sign">
            <p>
              I'm <strong>Pardha</strong>, building this solo. If you have feedback or
              just want to say hi, I'd love to hear from you.
            </p>
            <a href="mailto:getholdonapp@gmail.com" className="btn-contact">
              Send me a message
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default AboutPage;
